module.exports = __webpack_public_path__ + "img/menu_security.b2d61bd2.svg";